import { HDMUI_THEMES, ThemeService } from '@heidelberg/hdmui-angular';

export function onThemeInit(service: ThemeService, window: Window, forcedTheme?: HDMUI_THEMES): () => void {
    return () => {
        if (forcedTheme) {
            service.setTheme(forcedTheme);
        } else {
            setThemeBasedOnUrl(service, window);
        }
    };
}

function setThemeBasedOnUrl(service: ThemeService, window: Window): void {
    const queryString = window.location.search;
    if (queryString) {
        const urlParams = new URLSearchParams(queryString);
        const theme = urlParams.get('theme');
        if (
            theme &&
            [HDMUI_THEMES.DARK_THEME_CLASS.toString(), HDMUI_THEMES.LIGHT_THEME_CLASS.toString()].includes(theme)
        ) {
            service.setTheme(theme);
        }
    }
}
